/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Query {
  /**
   * 活动id
   */
  event_id: unknown;
  /**
   * 所有cos图片的类型，图片类型origin, small, mid，默认origin
   */
  cos_image_type?: unknown;
  /**
   * 来源：0-默认；1-活动大厅预览; 2-corwork运营端审核最新
   */
  source?: unknown;
  /**
   * 临时权限 当source=2 temp_token必须存在，不存在返回默认线上版，存在校验，权限过期返回没有权限
   */
  temp_token?: unknown;
}
/**
 * 活动标签
 */
export type Labels = string[];
/**
 * 活动滚动背景图列表
 */
export type BackgroundUrls = string[];
/**
 * 活动滚动背景图id列表
 */
export type BackgroundCosIds = string[];
/**
 * 日程列表
 */
export type Schedules = {
  schedule_id: string;
  schedule_name: string;
  start_time: string;
  end_time: string;
  /**
   * 该场次的门票库存
   */
  ticket_stock_num: number;
}[];
/**
 * 嘉宾列表
 */
export type Guest = {
  /**
   * 嘉宾照片
   */
  photo_url: string;
  /**
   * 嘉宾照片id
   */
  photo_cosId: string;
  /**
   * 嘉宾id
   */
  id: string;
  /**
   * 嘉宾名字
   */
  name: string;
  /**
   * 嘉宾介绍
   */
  introduction: string;
  /**
   * 公司
   */
  company: string;
  /**
   * 嘉宾职称
   */
  position: string;
  /**
   * 嘉宾权重
   */
  sort_weight: number;
}[];
export interface ActivitiesPublicRegistrationPageRes {
  /**
   * 1710129 无效活动id 或 被屏蔽
   */
  code: number;
  msg: string;
  data: Data;
  nonce: string;
}
export interface Data {
  activity_basic_info: ActivityBasicInfo;
  activity_introduction: ActivityIntroduction;
  guest: Guest;
  /**
   * 活动报名状态；0:暂未开售；1:报名终止；2:名额已满；3:立即报名
   */
  event_enroll_status: number;
  /**
   * ip归属地(精确到省)
   */
  ip_attribution: string;
}
/**
 * 活动基础信息
 */
export interface ActivityBasicInfo {
  /**
   * 活动标题
   */
  title: string;
  /**
   * 开始时间
   */
  start_time: number;
  /**
   * 结束时间
   */
  end_time: number;
  time_zone: string;
  /**
   * 最小价格
   */
  min_price: number;
  /**
   * 最大价格
   */
  max_price: number;
  /**
   * 是否展示价格
   */
  show_price: boolean;
  /**
   * 门票类型；1:套票；2:场次票
   */
  ticket_type: number;
  labels: Labels;
  /**
   * 活动状态，0为未发布，1为已发布
   */
  status: number;
  background_urls: BackgroundUrls;
  background_cosIds: BackgroundCosIds;
  /**
   * 活动地址
   */
  address: string;
  schedules: Schedules;
  /**
   * 主办方id
   */
  host_id: number;

  address_ext: {
    province: string;
    city: string;
    citycode: string;
    latitude: number;
    longitude: number;
  };
  /**
   * 0-门票报名，1-无限制准入
   */
  access_rule: number;
}
export interface ActivityIntroduction {
  /**
   * 活动介绍内容
   */
  content: string;
}

const ActivitiesPublicRegistrationPage = async (data: Query, ctx?: GetServerSidePropsContext) => {
  const res = await http.get<ActivitiesPublicRegistrationPageRes>(
    '/wemeet-tapi',
    '/v2/activities/public/registration-page',
    data,
    ctx,
  );

  return res;
};

export default ActivitiesPublicRegistrationPage;
